import { Box } from '@chakra-ui/react';
import React from 'react';

interface JaggedFooterForMobileProps {
  bgColor?: string;
}

export const JaggedBorderFooterMobile: React.FC<JaggedFooterForMobileProps> = ({
  bgColor = 'white',
}) => {
  return (
    <Box width="100%" height="140px" position="relative" overflow="hidden" lineHeight="0">
      <Box
        bottom="0px"
        position="absolute"
        left="0"
        width="100%"
        overflow="hidden"
        zIndex="2" // above image, below text
      >
        <Box
          as="svg"
          viewBox="0 0 480 673"
          width="100%"
          height="100%"
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
          transform="scaleX(-1)" // 👈 flips horizontally
        >
          {/* Jagged stroke on top */}
          <path
            fill="none"
            stroke="url(#footer_gradient)"
            strokeWidth="16"
            strokeMiterlimit="7.6613"
            shapeRendering="geometricPrecision"
            d="M-678.966 -48H563V650.166L468.924 647.017L435.288 652.793L451.581 635.988L338.025 658.663L300.923 651.693L309.802 665L227.168 648.066L244.793 662.782L72.6528 647.54L28.5039 661.192L36.9139 642.816L-45.6854 652.01L-70.3 640.715L-185.534 652.961L-200.638 645.439L-235.004 653.277L-229.02 639.663L-301.021 643.342L-342.015 651.215L-358.832 643.865L-446.203 651.06L-479.5 645.04L-526.116 656.129L-495.039 638.703L-620.617 652.327L-681 645.439L-678.966 -48Z"
          />

          {/* Fill below the jagged edge */}
          <path
            height="10px"
            fill={bgColor}
            d="M563 655V700H-681V640L-620.617 652.327L-495.039 638.703L-526.116 656.129L-479.5 645.04L-446.203 651.06L-358.832 643.865L-342.015 651.215L-301.021 643.342L-229.02 639.663L-235.004 653.277L-200.638 645.439L-185.534 652.961L-70.3 640.715L-45.6854 652.01L36.9139 642.816L28.5039 661.192L72.6528 647.54L244.793 662.782L227.168 648.066L309.802 665L300.923 651.693L338.025 658.663L451.581 635.988L435.288 652.793L468.924 647.017L563 655Z"
          />
          <defs>
            <linearGradient
              id="footer_gradient"
              x1="-681"
              y1="308.5"
              x2="563"
              y2="308.5"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#4371D4" />
              <stop offset="0.201923" stopColor="#8934C4" />
              <stop offset="0.495192" stopColor="#3D99E0" />
              <stop offset="0.8" stopColor="#8934C4" />
              <stop offset="1" stopColor="#4272D4" />
            </linearGradient>
          </defs>
        </Box>
      </Box>
    </Box>
  );
};
